import React, { useEffect, useState } from "react";
import QRCode from "qrcode";

const QRCodeGenerator = ({ url }) => {
  const [qrDataUrl, setQrDataUrl] = useState("");

  useEffect(() => {
    if (!url) return;

    // Genera el QR como DataURL
    QRCode.toDataURL(url, { width: 200, margin: 2 }, (err, dataUrl) => {
      if (err) {
        console.error(err);
        return;
      }
      setQrDataUrl(dataUrl);
    });
  }, [url]);

  return (
    <div style={{ textAlign: "center" }}>
      {qrDataUrl ? (
        <img src={qrDataUrl} alt="QR Code" />
      ) : (
        <p>Generando QR...</p>
      )}
    </div>
  );
};

export default QRCodeGenerator;
